export default "__VITE_PUBLIC_ASSET__34cee8a9__"